import SellerTableReducer from "./reducers/SellerTableReducer";
import SellerSaga from "./saga";

import IConfig from "interfaces/IConfig";
import { registerModals } from "modals";
import store from "rootStore";
import { permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";
import SellerSelectModal from "./modals/SellerSelectModal";

export const moduleName = "payment.seller";
export const url = "sellers";

const getConfig = (permissions: permissionsType, parentUrl: string) => {
    const config: IConfig = {
        active: false,
        routing: [],
        url,
    };

    let routing: routingType = [];

    if (permissions["payment.sellers.read"]) {
        config.active = true;

        store.reducerManager?.add("PaymentSellerTable", SellerTableReducer);
        store.injectSaga?.("PaymentSellerSaga", SellerSaga);
        registerModals({ SellerSelectModal });

        routing.push({
            path: url,
            element: (
                <AsyncComponent path="Payment/Seller/pages/SellerIndexPage" />
            ),
        });
    }

    if (permissions["payment.sellers.update"]) {
        routing.push({
            path: `${url}/:id/edit`,
            element: (
                <AsyncComponent path="Payment/Seller/pages/SellerEditPage" />
            ),
        });
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => parentUrl + "/" + item.path);
    }

    return { config, routing };
};

export default getConfig;
